module.exports = __webpack_public_path__ + "2472535d8e453e92d3f4cd5891d3b015.pdf";